import { createReducer, on } from '@ngrx/store';
import { Subject } from 'rxjs';
import * as notificationsActions from './notifications.actions';
import { ISendedNotification } from './notifications.actions';

export interface INotificationsState {
  notification?: ISendedNotification;
}

export const notificationsReducer = createReducer(
  { notifications: new Subject() } as INotificationsState,
  on(
    notificationsActions.sended,
    (state: INotificationsState, action: ISendedNotification) => {
      return { ...state, notification: action as ISendedNotification };
    },
  ),
);
